/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesh_No_ResultsInputs */



/**
* | output |
* | --- |
* | "Launch a communication test to inspect the mesh network" |
*
* @param {Mesh_No_ResultsInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const mesh_no_results = /** @type {((inputs?: Mesh_No_ResultsInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesh_No_ResultsInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Launch a communication test to inspect the mesh network")
	return /** @type {LocalizedString} */ ("Lancez un test de communication pour inspecter le  Mesh")
});